import { init, FullStory } from '@fullstory/browser';

let pendingCallbacks: (() => void)[] = [];
let isReady = false;

export function initFullStory(): void {
    try {
        init(
            { orgId: '8HR7J', devMode: process.env.NODE_ENV === 'development' },
            () => {
                isReady = true;
                pendingCallbacks.forEach((cb) => cb());
                pendingCallbacks = [];
            }
        );
    } catch {
        // Swallow errors (e.g. ad-blockers, network failures) so the app never
        // stalls due to a recording failure.
    }
}

/** Run a FullStory API call once the SDK is ready. Safe to call at any time. */
export function whenFullStoryReady(cb: () => void): void {
    if (isReady) {
        cb();
    } else {
        pendingCallbacks.push(cb);
    }
}
